import React, { useState } from 'react';
import { changePassword } from "../../../../services/userMangement/userManagement";
import { FaTimes } from 'react-icons/fa';
import PasswordInput from './../../../../components/password';

const ChangeUserPassewordModal = ({
  visible,
  fetchUsers,
  onHide,
  toast,
  selectedUser,
  setLoading,
  loading
}) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');

  const validateFields = () => {
    let isValid = true;
    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

    // Validate password
    if (!password) {
      setPasswordError('Password is required');
      isValid = false;
    } else if (!passwordRegex.test(password)) {
      setPasswordError('Password must be at least 8 characters long, include 1 uppercase letter, 1 number, and 1 special character');
      isValid = false;
    }

    // Validate confirm password
    if (!confirmPassword) {
      setConfirmPasswordError('Confirm Password is required');
      isValid = false;
    } else if (password !== confirmPassword) {
      setConfirmPasswordError('Passwords do not match');
      isValid = false;
    }

    return isValid;
  };

  const handleSave = async () => {
    if (!validateFields()) return;
    clearErrors();
    setLoading(true);

    try {
      const accessToken = JSON.parse(localStorage.getItem('access_token'));
      const payload = { new_password: password };

      const response = await changePassword(payload, accessToken, selectedUser.id);
      if (response) {
        await fetchUsers();
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: 'success',
          summary: 'Success',
          detail: response.data.message,
          life: 3000,
        });
        resetFields();
        onHide();
      }
    } catch (error) {
      console.error('Error saving user:', error);
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: 'warn',
        summary: 'Warning',
        detail: error.message,
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleChangePassword = (value) => {
    setPassword(value);
    if (passwordError) setPasswordError('');
  };

  const handleChangeConfirmPassword = (value) => {
    setConfirmPassword(value);
    if (confirmPasswordError) setConfirmPasswordError('');
  };

  const clearErrors = () => {
    setPasswordError('');
    setConfirmPasswordError('');
  };

  const resetFields = () => {
    setPassword('');
    setConfirmPassword('');
  };

  const handleCancel = () => {
    resetFields();
    clearErrors();
    onHide();
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-[rgba(44,52,79,1)] md:w-1/3 w-1/2 shadow-lg p-6 text-white">

        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Change Password</h2>
          <FaTimes onClick={handleCancel} className="cursor-pointer text-lg" />
        </div>

        <div className="field">
          <label htmlFor="email" className="block font-medium mb-2">Email Address</label>
          <input
            type="email"
            id="email"
            title='disabled'
            value={selectedUser?.email || ''}
            className="w-full border rounded-lg p-2 mb-2 border-[rgb(161,147,147)] focus:ring focus:ring-blue-500 bg-[rgba(255,255,255,0.09)] text-gray-400"
            disabled
          />
        </div>
        <div className="space-y-4">
          <PasswordInput
            label="Password"
            value={password}
            onChange={(e) => handleChangePassword(e.target.value)}
            required={true}
          />
          {passwordError && <span className="text-red-500 text-sm">{passwordError}</span>}

          <PasswordInput
            label="Confirm Password"
            value={confirmPassword}
            onChange={(e) => handleChangeConfirmPassword(e.target.value)}
            required={true}
          />
          {confirmPasswordError && <span className="text-red-500 text-sm">{confirmPasswordError}</span>}
        </div>

        <div className="mt-6 flex gap-4">
          <button
            onClick={handleSave}
            className={`bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 flex items-center justify-center ${loading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            disabled={loading}
          >
            {loading ? 'Saving...' : 'Save'}
          </button>
          <button
            onClick={handleCancel}
            className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangeUserPassewordModal;
